/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RecommendationForFinopsIdleGcpAdvisorResource extends models.RecommendationBaseForFinopsResource {
    constructor() {
        super();
        this.setDiscriminator("RecommendationForFinopsIdleGcpAdvisorResource");
    }

    getFixupPrototypeFunction() { return RecommendationForFinopsIdleGcpAdvisorResource.fixupPrototype; }

    static newInstance(model: Partial<RecommendationForFinopsIdleGcpAdvisorResource>): RecommendationForFinopsIdleGcpAdvisorResource {
        let obj = Object.assign(new RecommendationForFinopsIdleGcpAdvisorResource(), model);
        RecommendationForFinopsIdleGcpAdvisorResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RecommendationForFinopsIdleGcpAdvisorResource>): RecommendationForFinopsIdleGcpAdvisorResource {
        if (!model) return null;
        return RecommendationForFinopsIdleGcpAdvisorResource.newInstance(<RecommendationForFinopsIdleGcpAdvisorResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RecommendationForFinopsIdleGcpAdvisorResource) {
        if (!obj) return;

        models.RecommendationForFinopsIdleGcpAdvisorResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RecommendationForFinopsIdleGcpAdvisorResource): boolean {
        if (models.RecommendationBaseForFinopsResource.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, RecommendationForFinopsIdleGcpAdvisorResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
